import { queryClient, send } from "../fetch";
import { Plan } from "@utils/redux/slices/plans";

type EquivalentMultiUserPlanResponse = {
  equivalentMultiUserPlan: Plan;
  currentPlan: Plan;
  multiUserNoomPlanId: string;
};

type ProratedRefundDataResponse = {
  refundAmount: number;
  refundCurrency: string | null;
};

export type MultiUserPlanPeerResponse = {
  accessCode?: string;
  upid: string;
  isPrimaryUser: boolean;
  profileName?: string;
};

export const GET_PRORATED_REFUND_DATA_CACHE_KEY = ["proratedRefundData"];
export const GET_PEERS_CACHE_KEY = ["getPeers"];
export function makeEquivalentMultiUserPlanCacheKey(
  initialMultiUserNoomPlanId: string
) {
  return ["equivalentMultiUserPlan", initialMultiUserNoomPlanId];
}

export function getEquivalentMultiUserPlan(
  multiUserNoomPlanId: string
): Promise<EquivalentMultiUserPlanResponse> {
  const url = `/api/multiUserPlans/equivalentMultiUserPlan/?multiUserNoomPlanId=${multiUserNoomPlanId}`;
  return send("GET", url);
}

export function getProratedRefundData(): Promise<ProratedRefundDataResponse> {
  return send("GET", `/api/plans/proratedRefundData/`);
}

export function getPeers(): Promise<MultiUserPlanPeerResponse[]> {
  return send("GET", "/api/multiUserPlans/peers");
}

export async function loadProratedRefundData() {
  await queryClient.prefetchQuery(
    GET_PRORATED_REFUND_DATA_CACHE_KEY,
    getProratedRefundData,
    { retry: 3 }
  );
}

export async function loadEquivalentMultiUserPlan(multiUserNoomPlanId: string) {
  await queryClient.prefetchQuery(
    makeEquivalentMultiUserPlanCacheKey(multiUserNoomPlanId),
    () => getEquivalentMultiUserPlan(multiUserNoomPlanId),
    { retry: 3 }
  );
}
